/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DevicePropertyType {
    Invalid = 'Invalid',
    Text = 'Text',
    Number = 'Number'
}

export function DevicePropertyTypeFromJSON(json: any): DevicePropertyType {
    return DevicePropertyTypeFromJSONTyped(json, false);
}

export function DevicePropertyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevicePropertyType {
    return json as DevicePropertyType;
}

export function DevicePropertyTypeToJSON(value?: DevicePropertyType | null): any {
    return value as any;
}

